<script setup lang="ts">
import { computed } from 'vue';
import { useVideoPopupStore } from '~/stores/useVideoPopupStore';
import { router } from '@inertiajs/vue3';
import { isSsr } from '~/utils/ssr';
import { resolveVideoEmbedComponent } from '~/composables/useVideo';

const videoPopupStore = useVideoPopupStore();

const showPopup = computed(() => videoPopupStore.video !== null);
const video = computed(() => videoPopupStore.video);
const videoComponent = computed(() => (video.value ? resolveVideoEmbedComponent(video.value) : null));

if (!isSsr()) {
  router.on('start', () => {
    videoPopupStore.clearVideo();
  });
}
</script>

<template>
  <div v-if="showPopup" class="video-popup">
    <div class="video-popup__wrapper">
      <div v-if="video && videoComponent" class="video-popup__content">
        <component :is="videoComponent" v-bind="{ video }" />
      </div>
    </div>
    <button class="video-popup__close" @click.prevent="videoPopupStore.clearVideo()">
      <span class="sr-only text-white">Close Popup</span>
      <span class="video-popup__close-icon" />
      <span class="video-popup__close-icon" />
    </button>
  </div>
</template>

<style lang="scss" scoped>
.video-popup {
  @apply fixed top-0 left-0 z-[10001] w-full h-full flex justify-center items-center bg-[color:rgb(0_0_0_/_90%)];

  &__wrapper {
    @apply w-[calc(100%_-_40px)] max-h-screen py-[30px] overflow-auto;
    @apply md:w-[600px];
    @apply lg:w-[950px] lg:py-[50px];
  }

  &__close {
    @apply absolute top-[10px] right-[10px] bg-white hover:bg-[color:rgba(255_255_255_/_70%)] rounded-full w-[40px] h-[40px] border-0 cursor-pointer flex items-center justify-center transition-colors duration-[400ms];
    @apply lg:h-[50px] lg:w-[50px] lg:top-[15px] lg:right-[15px];

    &-icon {
      @apply w-[25px] h-[2px] bg-black absolute -rotate-45 last:rotate-45;
    }
  }
}
</style>
